import { INTAKE_COPY_SPANISH } from "./intake-copy-spanish";
const CONTACT_STEP_TITLE = "How can we reach you?";

/** Spanish for chrome and the default seller questions, used before the translation cache fills. */
export const SPANISH_CHROME: Record<string, string> = {
  ...INTAKE_COPY_SPANISH,
  "Let’s take it one step at a time.": "Vamos paso a paso.",
  "Thanks for sharing those details.": "Gracias por compartir estos detalles.",
  "You’re at the last step of this section.":
    "Ya estás en el último paso de esta sección.",
  "Just your contact details to wrap up this part.":
    "Solo faltan tus datos de contacto para terminar esta parte.",
  "Almost there. Just your contact details left.":
    "Ya casi terminamos. Solo faltan tus datos de contacto.",
  "One last step, then you’re all set.": "Un último paso y listo.",
  Required: "Obligatorio",
  "Loading…": "Cargando…",
  "Saving…": "Guardando…",
  Years: "Años",
  Months: "Meses",
  "Number of years": "Número de años",
  "Number of months": "Número de meses",
  "Years or months": "Años o meses",
  "Add item": "Agregar elemento",
  "Remove entry": "Eliminar elemento",
  "Your business": "Tu negocio",
  Revenue: "Ingresos",
  Motivation: "Motivación",
  Timeline: "Cronograma",
  "How to reach you": "Cómo contactarte",
  "Your details": "Tus datos",
  "Thank you": "Gracias",
  "This answer is required.": "Esta respuesta es obligatoria.",
  "Unable to save your answers.": "No se pudieron guardar tus respuestas.",
  Yes: "Sí",
  No: "No",
  [CONTACT_STEP_TITLE]: "¿Cómo podemos contactarte?",
  Continue: "Continuar",
  Back: "Atrás",
  Submit: "Enviar",
  Done: "Listo",
  "Talk with {First}": "Habla con {First}",
  "Your details are only shared with {broker}.":
    "Tus datos solo se comparten con {broker}.",
  "What industry is your business in?": "¿En qué industria está tu negocio?",
  "What kind of business do you own?": "¿Qué tipo de negocio tienes?",
  "What’s your approximate annual revenue?":
    "¿Cuál es el ingreso anual aproximado de tu negocio?",
  "What’s prompting you to explore this?": "¿Qué te motiva a explorar esto?",
  "When might you want to move forward?": "¿Cuándo te gustaría avanzar?",
  "I’m not sure yet": "Aún no estoy seguro",
  "How would you prefer {First} to reach you?":
    "¿Cómo prefieres que {First} te contacte?",
  "Phone call": "Llamada telefónica",
  Email: "Correo electrónico",
  "Text first, then call": "Primero un mensaje, luego una llamada",
  "What’s the best number to reach you?":
    "¿Cuál es el mejor número para contactarte?",
  "Considering retirement or stepping back":
    "Considerando el retiro o dar un paso atrás",
  "Approached by a potential buyer": "Contactado por un posible comprador",
  "Exploring partial liquidity options":
    "Explorando opciones de liquidez parcial",
  "Planning succession or transition": "Planeando la sucesión o transición",
};

export function spanishChromeLabel(value: string): string {
  return SPANISH_CHROME[value] ?? value;
}
